import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _requestCount = 0;
  private _loading = signal(false);
  readonly loading = this._loading.asReadonly();

  show() {
    this._requestCount++;
    this._loading.set(true);
  }

  hide() {
    this._requestCount = Math.max(this._requestCount - 1, 0);
    if (this._requestCount === 0) {
      this._loading.set(false);
    }
  }
}
